const css = `.base-panel .panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  background: var(--surface-section);
  border-bottom: 1px solid var(--surface-border);
  width: 100%;
  padding: 12px;
}
.base-panel .panel-header h4 {
  min-height: 32px;
  line-height: 32px;
}
.base-panel .panel-header .p-button {
  max-height: 32px;
}
.base-panel .panel-header .p-button-icon-only {
  max-width: 32px;
}
.base-panel .panel-header .header-right {
  display: flex;
  justify-content: flex-end;
}
.base-panel .panel-header .header-right .p-button-icon-only {
  height: 32px;
  width: 32px;
  padding: 0px;
}
.base-panel .p-sidebar-icons {
  display: none;
}
.base-panel .p-sidebar-content {
  padding: 0 !important;
  gap: 0 !important;
}
.base-panel .panel-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 16px;
}
.base-panel .panel-footer {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  position: static;
  padding: 16px;
  bottom: 0;
  width: 100%;
  background: var(--surface-section);
  border-top: 1px solid var(--surface-border);
}
.base-panel .panel-footer .footer-right {
  margin-left: auto;
}
.base-panel .panel-footer .p-button {
  min-width: 120px;
}
.base-panel .panel-footer .panel-delete-button {
  min-width: 100px;
}
.base-panel .panel-footer .attendance-split-button .p-splitbutton-menubutton {
  min-width: unset;
}
.base-panel .p-sidebar-header {
  padding: 0;
}
.base-panel .p-sidebar-content {
  display: flex;
  flex-direction: column;
  padding: 0;
  background: var(--surface-ground);
}
@media screen and (max-width: 768px) {
  .base-panel .panel-content {
    padding: 16px;
  }
  .base-panel .panel-content h3 {
    font-size: var(--font-size-lg);
    margin-bottom: 16px;
  }
  .base-panel .panel-footer {
    padding: 12px 16px;
  }
  .base-panel .panel-footer .p-button {
    min-width: 100px;
    font-size: var(--font-size-sm);
    padding: 8px 16px;
  }
}

@media screen and (max-width: 480px) {
  .panel-header h4 {
    font-size: var(--font-size-lg);
  }
}
.full-width-panel.p-sidebar {
  width: 100% !important;
  max-width: 100% !important;
}
.full-width-panel .panel-content {
  padding: 16px 24px;
}
@media screen and (max-width: 768px) {
  .full-width-panel .panel-content {
    padding: 16px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
